import React from "react";
import NewHeader from "@/components/NewHeader";
import Footer from "@/components/Footer";
import LocalAttractionsHeroSection from "@/components/local-attractions/HeroSection";
import QuickAccessTabs from "@/components/local-attractions/QuickAccessTabs";
import SeasonalCarousel from "@/components/local-attractions/SeasonalCarousel";
import SeasonalGuide from "@/components/SeasonalGuide";
import GuestBenefits from "@/components/local-attractions/GuestBenefits";
import TransportationInfo from "@/components/local-attractions/TransportationInfo";
import CTASection from "@/components/local-attractions/CTASection";
import SEO from "@/components/SEO";
import { useLanguage } from "@/contexts/LanguageContext";
import { getPageSEO, SEOLanguage } from "@/data/seoTranslations";
import { getTranslatedStructuredData } from "@/data/structuredDataTranslations";
import { createBreadcrumbSchema } from "@/data/structuredData";

const LocalAttractions = () => {
  const { language } = useLanguage();
  const seoLang = language as SEOLanguage;
  const seoData = getPageSEO("localAttractions", seoLang);
  const breadcrumbSchema = createBreadcrumbSchema([
    { name: "Home", url: "https://beatenberg-resortspa.ch/" },
    {
      name: "Local Attractions",
      url: "https://beatenberg-resortspa.ch/local-attractions",
    },
  ]);

  return (
    <div className="min-h-screen" data-oid="fzk7ec2">
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical="/local-attractions"
        language={seoLang}
        structuredData={[
          getTranslatedStructuredData.attractions(seoLang),
          getTranslatedStructuredData.seasonalActivities(seoLang),
          breadcrumbSchema,
        ]}
        data-oid="oefil5j"
      />

      <NewHeader data-oid=".2z9.-h" />
      <main data-oid="rq28ycx">
        <LocalAttractionsHeroSection data-oid="tkbf9ly" />
        <QuickAccessTabs data-oid="_kpm.2n" />
        <SeasonalCarousel data-oid="cvzenn2" />
        <SeasonalGuide data-oid="xx2gwlf" />
        <GuestBenefits data-oid="gzv089b" />
        <TransportationInfo data-oid="ikxvgz5" />
        <CTASection data-oid="shcnbv." />
      </main>
      <Footer data-oid="4hmrwus" />
      {/* <BottomDockNavigation /> */}
    </div>
  );
};

export default LocalAttractions;
